// extracted by mini-css-extract-plugin
export default {"label":"UserLabels_label__Uluve","labelsWrapper":"UserLabels_labelsWrapper__Qb+oy","emptyUserLabel":"UserLabels_emptyUserLabel__fqMjW"};